<template>
  <div class="text">
      <!-- <p>
      We are a <b>cinematic</b>, <b>instrumental</b>,  <b>progressive</b> 6 piece hailing from <b>Louisville, Kentucky</b>.
      </p> -->
      <p>
      Our <b>full-bodied</b>, <b>dynamic sound</b>, overlapping <b>polyrhythms</b>, and interweaving <b>melodies</b> will satisfy the adventurous ear.  
      </p>
      <p>
      When you book us, expect <b>timely professionalism</b>, <b>quick breakdown</b>, <b>punk ethos</b>, and a <b>booming musical experience</b> that will shake you to your core.  We are open to festivals, cross-country performances, and look forward to international shows.
      </p>
      <p>
      Whether you need a live soundtrack for your newest DnD campaign, musical performances for your latest event, or lively soundscapes for your next film project, Isolation Tank Ensemble will be an unforgettable execution of musical vision.
      </p>
    </div>
</template>

<script>
export default {
  name: 'HomeView',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
